import './scss/tickers.scss';
import './js/tickers';
import { Tabs } from './js/Tabs';

setTimeout( () => {
	new Tabs( '(max-width: 767px)' ).init();
}, 1000 );
